export const enReferencesDropdown = {
  "clients": {
    "title": "Our Clients",
    "description": "Working with diverse clients from startups to enterprises across industries."
  },
  "partners": {
    "title": "Our Partners",
    "description": "Collaborating with leading tech providers to deliver cutting-edge solutions."
  }
};

export const frReferencesDropdown = {
  "clients": {
    "title": "Nos Clients",
    "description": "Travailler avec des clients divers, des startups aux grandes entreprises, dans tous les secteurs."
  },
  "partners": {
    "title": "Nos Partenaires",
    "description": "Collaborer avec des fournisseurs de technologie de premier plan pour offrir des solutions de pointe."
  }
};

export const nlReferencesDropdown = {
  "clients": {
    "title": "Onze Klanten",
    "description": "Samenwerken met diverse klanten, van startups tot ondernemingen in verschillende sectoren."
  },
  "partners": {
    "title": "Onze Partners",
    "description": "Samenwerken met toonaangevende technologieproviders om geavanceerde oplossingen te leveren."
  }
};

export const deReferencesDropdown = {
  "clients": {
    "title": "Unsere Kunden",
    "description": "Zusammenarbeit mit vielfältigen Kunden, von Startups bis zu Unternehmen in verschiedenen Branchen."
  },
  "partners": {
    "title": "Unsere Partner",
    "description": "Zusammenarbeit mit führenden Technologieanbietern, um innovative Lösungen zu liefern."
  }
};